import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollPage = () => {
  const location = useLocation();

  useEffect(() => {
    // Prevent React Router or browser from restoring scroll position
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Only scroll to the top if there's no hash in the URL
    if (!location.hash) {
      const timeout = setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth", // Use "smooth" for smooth scrolling
        });
      }, 0);

      return () => clearTimeout(timeout); // Cleanup timeout
    }
  }, [location]);

  return null;
};

export default ScrollPage;
